<template>
  <v-container fluid class="pa-0">
    <v-row no-gutters v-show="!editMode">
      <ContactList :CustomerId="Customer.Id" showdetails :closable="false" ref="ContactList" ContactList includeInactive @Select="setContact"
        @New="edit({ CustomerId: Customer.Id, IsActive: true })" @Edit="e => edit(e)">
      </ContactList>
    </v-row>
    <v-row no-gutters v-show="editMode">
      <ContactEdit :key="editKey" :CustomerId="Customer.Id" :Contact="editObject" @Created="setContact"
        @Changed="setContact" @Close="editMode = false">
      </ContactEdit>
    </v-row>
  </v-container>
</template>


<script>
import ContactList from "@/components/Preview/Customer/ContactList.vue";
import ContactEdit from "@/components/Preview/Customer/ContactEdit.vue";

export default {
  name: "CustomerContacts",
  props: {
    Customer: Object,
  },
  components: {
    ContactList,
    ContactEdit,
  },

  data() {
    return {
      editKey: 1,
      editMode: false,
      editObject: null,
    };
  },

  methods: {
    edit(contact) {
      this.editObject = Object.assign({}, contact);
      this.editKey++;
      this.editMode = true;
    },
    setContact(updated) {
      if (!this.Customer.DefaultCustomerPerson || updated.Id == this.Customer.DefaultCustomerPerson.Id) {
        this.Customer.DefaultCustomerPerson = updated;
      }
      this.$refs.ContactList.updateItem(updated);
      this.editMode = false;
    },
  },

  computed: {
    AllowChangeContact() {
      return !this.CustomerPersonsReadonly && this.checkPermission("Actions", "editCustomerContact");
    },
  },

  watch: {},
};
</script>


<style lang='scss' scoped></style>